import React from 'react';

import UniversalNavLink from '../UniversalNavLink';
import UniversalSidebarSubmenu from '../UniversalSidebar/UniversalSidebarSubmenu/UniversalSidebarSubmenu';

import type { NavItem } from '../../constants/links';

type OutOfAppLinksProps = {
  isCollapsed: boolean;
  navigationItems: Array<NavItem>;
};

const OutOfAppLinks = ({
  isCollapsed,
  navigationItems,
}: OutOfAppLinksProps) => {
  return (
    <React.Fragment>
      {navigationItems.map((navigationItem) => {
        let itemToRender;
        if (navigationItem.variant === 'link') {
          itemToRender = (
            <UniversalNavLink
              href={navigationItem.href}
              isCollapsed={isCollapsed}
              isSelected={false}
              isSidebar={true}
              text={navigationItem.text}
            />
          );
        }

        if (navigationItem.variant === 'variant-a') {
          const heroAreaSubmenu = navigationItem.heroArea.submenu.map(
            (item) => {
              return {
                href: item.href || null,
                text: item.text,
              };
            }
          );

          const promoArea = {
            href: navigationItem.promoArea.header.href || null,
            text: navigationItem.promoArea.header.heading,
            submenu: navigationItem.promoArea.submenu.map((item) => {
              return {
                href: item.href || null,
                text: item.tag ? `${item.text} (${item.tag})` : item.text,
              };
            }),
          };

          const combinedSubmenus = [...heroAreaSubmenu, promoArea];

          itemToRender = (
            <UniversalSidebarSubmenu
              links={combinedSubmenus}
              text={navigationItem.text}
            />
          );
        }

        if (
          navigationItem.variant === 'variant-b' ||
          navigationItem.variant === 'variant-c'
        ) {
          itemToRender = (
            <UniversalSidebarSubmenu
              links={navigationItem.submenu}
              text={navigationItem.text}
            />
          );
        }

        return itemToRender ? (
          <li key={navigationItem.text}>{itemToRender}</li>
        ) : null;
      })}
    </React.Fragment>
  );
};

export default OutOfAppLinks;
